"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestError = exports.handleInputs = exports.handleInput = exports.propnames = exports.propname = exports.required = undefined;
exports.handleForm = handleForm;

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _assert = require("@swarm2/assert");

var _reselect = require("reselect");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//export {dataToJS, pathToJS} from 'react-redux-firebase' // for testing/comparison

var required = exports.required = function required(fn) {
  return function (state, props) {
    return (0, _assert.assert)(fn(state, props));
  };
};

// <form> stuff
// Select helpers.
var propname = exports.propname = function propname(name) {
  return function (state, props) {
    return props[name];
  };
};
var propnames = exports.propnames = function propnames() {
  for (var _len = arguments.length, names = Array(_len), _key = 0; _key < _len; _key++) {
    names[_key] = arguments[_key];
  }

  return names.map(propname);
};

var handleInput = exports.handleInput = function handleInput(name) {
  return (0, _reselect.createSelector)(function (state, props) {
    return props[name];
  }, function (setter) {
    return function (event) {
      return setter(event.target.value);
    };
  });
};
var handleInputs = exports.handleInputs = function handleInputs() {
  for (var _len2 = arguments.length, names = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    names[_key2] = arguments[_key2];
  }

  return (0, _reselect.createStructuredSelector)((0, _lodash2.default)(names).keyBy().mapValues(handleInput).value());
};

var requestError = exports.requestError = (0, _reselect.createSelector)(propname("request"), function (req) {
  return req.state === "ERROR" ? req.error : null;
});

function handleForm(setRequest, handler) {
  return function (event) {
    setRequest({ state: "PENDING" });
    try {
      if (event) event.preventDefault();
      handler().then(function (result) {
        setRequest({ state: "SUCCESS", result: result });
      }, function (error) {
        setRequest({ state: "ERROR", error: error });
      });
    } catch (error) {
      setRequest({ state: "ERROR", error: error.message, source: "catch" });
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ../core/lib/containers/util/form.js
// module id = 56
// module chunks = 0